import { ImageProps } from "@commonlibs";
import clsx from "clsx";
import { TableImageRoot } from "./TableImage.styles";

function TableImage({ className, ...rest }: ImageProps) {
    return <TableImageRoot className={clsx("table-image", className)} {...rest} />;
}

export default TableImage;
